import { render, staticRenderFns } from "./UserSwitch.vue?vue&type=template&id=b2052fba&"
import script from "./UserSwitch.vue?vue&type=script&lang=js&"
export * from "./UserSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports